import { observable, action} from 'mobx';
import {getNextNodeContent } from '../apis/req';
import * as Util from '../util/formUtil';
export default class ShowContentStore{

    @observable spinning = false;
    auto2NextNodeNames="";
    auto2Operators=[];
    auto2NextNodeids="";
    timer;
    constructor(){
        this.changeSpining4True = this.changeSpining4True.bind(this);
        this.changeSpining4False = this.changeSpining4False.bind(this);
        this.getNextNode = this.getNextNode.bind(this);
        this.startInterval = this.startInterval.bind(this);
    }
    @action
    changeSpining4True = ()=>{
        this.spinning = true;
    }

    changeSpining4False = ()=>{
        this.spinning = false;
    }

    startInterval = (requestid,nodeid,sessionkey)=>{
       this.timer= setInterval(()=>{
			this.getNextNode(requestid,nodeid,sessionkey)
		},200);
       setTimeout(()=>{
           clearInterval(this.timer);
           this.changeSpining4False();
       },7000);
    }

    getNextNode=(requestid,nodeid,sessionkey)=>{
        let params={
            requestid,
            nodeid,
            sessionkey:sessionkey
        }
        getNextNodeContent(params).then((data)=>{
            if(data&&!data.isAutoApprove){
                this.auto2NextNodeNames = data.auto2NextNodeNames;
                this.auto2Operators = data.auto2Operators;
                this.auto2NextNodeids = data.auto2NextNodeids;
                clearInterval(this.timer);
                this.changeSpining4False();
                Util.reloadRequestPage({requestid,sessionkey:sessionkey});
            }
        }).catch(()=>{
            clearInterval(this.timer);
            this.changeSpining4False();
        });
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/showContentStore.js